/** @format */
import process from "process";
const API_BASE_URL = process.env.REACT_APP_API_URL; // Remplacez par l'URL de base de votre API

export async function getDocByStatus(token, Status, ModelId = null) {
  const apiUrl = `${API_BASE_URL}/document/list/bystatus`;

  const body = ModelId ? { ModelId: ModelId } : {};
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        body,
        Status: Status,
        ModelId: ModelId,
      }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data.message.list;
  } catch (error) {
    throw new Error(error);
  }
}



export async function getDocByStatusWithInstance(token, Status, ModelId = null, InstanceId = null) {
  const apiUrl = `${API_BASE_URL}/document/list/bystatus`;

  const payload = { Status };
  if (ModelId) payload.ModelId = ModelId;
  if (InstanceId) {
    payload.InstanceId = InstanceId;
    payload.Instance = InstanceId; 
  }

  try {
    const authHeader = token && token.startsWith("Bearer ") ? token : `Bearer ${token}`;
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: authHeader,
      },
      body: JSON.stringify(payload),
    });
    const text = await response.text();
    let data;
    try {
      data = text ? JSON.parse(text) : null;
    } catch (e) {
      console.warn("[API:getDocByStatus] response not json:", text);
      data = null;
    }

    const list = data?.message?.list ?? data?.list ?? (Array.isArray(data) ? data : []);
    return list || [];
  } catch (error) {
    // console.warn("getDocByStatus error:", error);
    return [];
  }
}
